var map = {
	"./giftcard_active.svg": "dd62",
	"./giftcard_expired.svg": "3abc",
	"./giftcard_used.svg": "7e26",
	"./referral_active.svg": "d72d",
	"./referral_expired.svg": "d394",
	"./referral_used.svg": "8195",
	"./voucher_active.svg": "a9fd",
	"./voucher_expired.svg": "4f79",
	"./voucher_used.svg": "5c6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "740c";